<template>
    <section class="content">
        <div class="container-fluid">
            <div class="card">
                <div class="fn-header">
                    การจัดการแฟลชเซลล์
                </div>


                <div class="row search-section">
                    <div class="col-sm-2 col-search">

                        <button type="button" class="btn bg-teal waves-effect btn-search" @click="add()">
                            <i class="material-icons">add_box</i>
                            <span>สร้างแฟลชเซลล์</span>
                        </button>

                    </div>
                    <div class="col-sm-5 col-search"></div>
                    <div class="col-sm-2 col-search">
                        <input type="text" class="search-textbox" v-model="key"
                            placeholder="กรุณากรอกชื่อแฟลชเซลล์ เพื่อค้นหา" style="width:100%;margin-top:5px">
                    </div>

                    <div class="col-sm-2 col-search">
                        <button type="button" class="btn bg-blue-grey  waves-effect btn-search" :disabled="searching"
                            @click="search(1)">
                            <i class="material-icons">search</i>
                            <span>ค้นหา</span>
                        </button>
                    </div>
                    <div class="col-sm-1 col-search">
                        <button type="button" class="btn bg-grey waves-effect btn-search" :disabled="searching"
                            @click="reset()">
                            <i class="material-icons">refresh</i>
                            <span>Reset</span>
                        </button>
                    </div>

                </div>
                <div class="row ">
                    <div class="col-sm-12 " style="text-align: right;">
                        <img src="static/images/excel.png" class="excel-icon" alt="download excel"
                            style="margin-right: 15px;cursor: pointer;" @click="download()" />
                    </div>
                </div>
                <div class="body table-responsive" style="width:100%">
                    <div
                        style="margin-bottom: 20px;padding: 20px;border: 1px solid #ccc;border-radius: 5px;background: #f9f9f9;">
                        <div class="row">
                            <div class="col-sm-12" style="text-align: left;">
                                <b>เวลาเริ่มขาย:</b> {{ start_flash_str }}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12" style="text-align: left;">
                                <b> เวลาสิ้นสุด:</b> {{ end_flash_str }}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-2" style="text-align: left;">
                                <button type="button" class="btn bg-primary waves-effect btn-search" @click="setting()">
                                    <i class="material-icons">settings</i>
                                    <span>ตั้งค่า</span>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="preloader pl-size-xl" v-if="searching == true || loading == true">
                        <div class="spinner-layer pl-orange">
                            <div class="circle-clipper left">
                                <div class="circle"></div>
                            </div>
                            <div class="circle-clipper right">
                                <div class="circle"></div>
                            </div>
                        </div>
                    </div>
                    <div v-else>


                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th class="fn-th" style="width: 80px;">No.</th>

                                    <th class="fn-th">เกม</th>
                                    <th class="fn-th">ชื่อแพ็คเกจ</th>
                                    <th class="fn-th">ราคา Wepay</th>
                                    <th class="fn-th">ราคา Wepay2</th>
                                    <th class="fn-th">ราคา Wepay3</th>
                                    <th class="fn-th">ราคา</th>
                                    <th class="fn-th">กำไร</th>
                                    <th class="fn-th">ส่วนลด(%)</th>
                                   
                                    <th class="fn-th">สถานะ</th>
                                    <th class="fn-th">แก้ไข</th>
                                    <th class="fn-th">ลบ</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in items" :key="'p-' + item.id"
                                    :class="{ 'fn-tr-light': index % 2, 'fn-tr-dark': !(index % 2) }">
                                    <td v-html="((page - 1) * perpage) + index + 1"></td>


                                    <td style="text-align: center;">
                                        <span>{{ item.game_name }}</span>
                                    </td>

                                    <td style="text-align: center;">
                                        <span>{{ item.package_name }}</span>
                                    </td>
                                    <td style="text-align: center;">
                                        <span>{{ item.wepay_price }}</span>
                                    </td>
                                    <td style="text-align: center;">
                                        <span>{{ item.wepay_price2 }}</span>
                                    </td>
                                    <td style="text-align: center;">
                                        <span>{{ item.wepay_price3 }}</span>
                                    </td>
                                    <td style="text-align: center;">
                                        <span>{{ item.price }}</span>
                                    </td>
                                    <td style="text-align: center;">
                                        <span>{{ item.profit }}</span>
                                    </td>
                                    <td style="text-align: center;">
                                        <span>{{ item.discount }}</span>
                                    </td>
                                  
                                    <td>
                                        <span v-if="item.active == '1'" style="color:green;">Active</span>
                                        <span v-else style="color:red;">Inactive</span>
                                    </td>

                                    <td>
                                        <span @click="edit(item.id)">
                                            <a href="#">
                                                <i class="material-icons fn-icon">mode_edit</i>
                                            </a>
                                        </span>
                                    </td>
                                    <td>
                                        <span @click="del(item.id)">
                                            <a href="#">
                                                <i class="material-icons fn-icon" style="color:red;">cancel</i>
                                            </a>
                                        </span>
                                    </td>

                                </tr>
                            </tbody>

                        </table>
                    </div>

                    <Paginate v-model=page :page-count=pages :page-range="5" :click-handler="search" :prev-text="'Prev'"
                        :next-text="'Next'" :container-class="'fn-pagination'" />


                </div>
            </div>
        </div>
        <div class="modal fade" id="game-modal" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header" style="padding:10px">

                        <span style="color: #466aa7;font-size: 15px;font-weight: bold;">สร้างเกมแพ็คเกจ</span>
                    </div>
                </div>
                <div class="modal-body" style="background:white;min-height: 0;">

                    <div class="row" style="margin-top: 15px;">
                        <div class="col-sm-2  col-label">
                            <span>เกม</span>
                        </div>
                        <div class="col-sm-10">

                            <select v-model="game_id" class="form-control  show-tick fn-required"
                                :disabled="game_id > 0" @change="getPackage(game_id)">
                                <option :value="0">เลือกเกม</option>
                                <option v-for="(value, index) in games" :key="'game-key-' + index" :value="value.id"
                                    v-html="value.game_name"></option>
                            </select>
                        </div>
                    </div>
                    <div class="row" style="margin-top: 15px;">
                        <div class="col-sm-2  col-label">
                            <span>ชื่อแพ็คเกจ</span>
                        </div>
                        <div class="col-sm-10">

                            <input type="text" class="form-control fn-required" v-model="package.package_name"
                                placeholder="กรุณากรอกชื่อแพ็คเกจ">
                        </div>
                    </div>
                    <div class="row" style="margin-top: 15px;">
                        <div class="col-sm-2 col-label">
                            <span>ราคา(Wepay)</span>
                        </div>
                        <div class="col-sm-6">
                            <select v-model="package.wepay_price" class="form-control  show-tick fn-required">

                                <option v-for="(value, index) in prices" :key="'company-key-' + index" :value="value"
                                    v-html="value"></option>
                            </select>
                        </div>
                        <div class="col-sm-4" style="text-align: left;padding-top: 5px;">
                            <span style="color: red;font-size: 12px;">*ราคาที่มาจาก Wepay</span>
                        </div>
                    </div>
                    <div class="row" style="margin-top: 15px;">
                        <div class="col-sm-2 col-label">
                            <span>ราคา(Wepay)2</span>
                        </div>
                        <div class="col-sm-6">
                            <select v-model="package.wepay_price2" class="form-control  show-tick fn-required">
                                <option :value="0">0</option>
                                <option v-for="(value, index) in prices" :key="'company-key-' + index" :value="value"
                                    v-html="value"></option>
                            </select>
                        </div>
                        <div class="col-sm-4" style="text-align: left;padding-top: 5px;">
                            <span style="color: red;font-size: 12px;">*ราคาที่มาจาก Wepay 2</span>
                        </div>
                    </div>
                    <div class="row" style="margin-top: 15px;">
                        <div class="col-sm-2 col-label">
                            <span>ราคา(Wepay)3</span>
                        </div>
                        <div class="col-sm-6">
                            <select v-model="package.wepay_price3" class="form-control  show-tick fn-required">
                                <option :value="0">0</option>
                                <option v-for="(value, index) in prices" :key="'company-key-' + index" :value="value"
                                    v-html="value"></option>
                            </select>
                        </div>
                        <div class="col-sm-4" style="text-align: left;padding-top: 5px;">
                            <span style="color: red;font-size: 12px;">*ราคาที่มาจาก Wepay 3</span>
                        </div>
                    </div>
                    <div class="row" style="margin-top: 15px;">
                        <div class="col-sm-2 col-label">
                            <span>ราคา(Wepay)4</span>
                        </div>
                        <div class="col-sm-6">
                            <select v-model="package.wepay_price4" class="form-control  show-tick fn-required">
                                <option :value="0">0</option>
                                <option v-for="(value, index) in prices" :key="'company-key-' + index" :value="value"
                                    v-html="value"></option>
                            </select>
                        </div>
                        <div class="col-sm-4" style="text-align: left;padding-top: 5px;">
                            <span style="color: red;font-size: 12px;">*ราคาที่มาจาก Wepay 4</span>
                        </div>
                    </div>
                    <div class="row" style="margin-top: 15px;">
                        <div class="col-sm-2 col-label">
                            <span>ราคา</span>
                        </div>
                        <div class="col-sm-6">
                            <input type="number" class="form-control fn-required" v-model="package.price"
                                placeholder="กรุณากรอกราคา">
                        </div>
                    </div>
                    <div class="row" style="margin-top: 15px;">
                        <div class="col-sm-2 col-label">
                            <span>กำไร</span>
                        </div>
                        <div class="col-sm-6">
                            <input type="number" class="form-control fn-required" v-model="package.profit"
                                placeholder="กรุณากรอกกำไร">
                        </div>
                    </div>
                    <div class="row" style="margin-top: 15px;">
                        <div class="col-sm-2 col-label">
                            <span>ส่วนลด(%)</span>
                        </div>
                        <div class="col-sm-6">
                            <input type="number" class="form-control fn-required" v-model="package.discount"
                                placeholder="กรุณากรอกส่วนลด">
                        </div>
                    </div>
                    <div>

                    </div>
                   
                    <div class="row" style="margin-top: 15px;">
                        <div class="col-sm-2 col-label">
                            <span>สถานะ</span>
                        </div>
                        <div class="col-sm-6">
                            <select class="form-control  show-tick fn-required" v-model="package.active">
                                <option value="1">Active</option>
                                <option value="0">Inactive</option>
                            </select>
                        </div>
                    </div>

                </div>
                <div class="modal-footer" style="background:white">
                    <button type="button" class="btn btn-primary waves-effect" style="width: 150px;"
                        @click="handleSave()">บันทึก</button>
                    <button type="button" class="btn btn-default waves-effect" style="width: 150px;"
                        data-dismiss="modal">ปิด</button>
                </div>
            </div>
        </div>

        <div class="modal fade" id="flash-modal" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header" style="padding:10px">

                        <span style="color: #466aa7;font-size: 15px;font-weight: bold;">ตั้งค่าเวลา</span>
                    </div>
                </div>
                <div class="modal-body" style="background:white;min-height: 0;">

                    <div class="row" style="margin-top: 15px;">
                        <div class="col-sm-2 col-label">
                            <span>เวลาเริ่มขาย</span>
                        </div>
                        <div class="col-sm-6" style="text-align: left;">
                            <date-picker v-model="start_flash"  format="DD-MM-YYYY HH:mm" type="datetime" placeholder=""/>
                        </div>
                    </div>
                      <div class="row" style="margin-top: 15px;">
                        <div class="col-sm-2 col-label">
                            <span>เวลาสิ้นสุด</span>
                        </div>
                        <div class="col-sm-6" style="text-align: left;">
                            <date-picker v-model="end_flash"  format="DD-MM-YYYY HH:mm" type="datetime" placeholder=""/>
                        </div>
                    </div>
                   
                </div>
                <div class="modal-footer" style="background:white">
                    <button type="button" class="btn btn-primary waves-effect" style="width: 150px;"
                        @click="updateFlashDate()">บันทึก</button>
                    <button type="button" class="btn btn-default waves-effect" style="width: 150px;"
                        data-dismiss="modal">ปิด</button>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import GameService from '../../service/GameService'
import WepayService from '../../service/WepayService'
import FlashPackageService from '../../service/FlashPackageService'
import helper from '../../classes/helper'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import moment from 'moment'
import alertBox from '../../classes/alertBox'
import Paginate from 'vuejs-paginate'

export default {
    name: "FlashPackageManage",
    components: {
        DatePicker,
        Paginate
    },
    data() {
        return {
            user: JSON.parse(localStorage.getItem('user')),
            page: 1,
            perpage: 50,
            total: 0,
            pages: 0,
            items: [],
            games: [],
            gameData: [],
            prices: [],
            package: {},
            game_id: 0,
            key: "",
            flash_date: {
                id: 0,
                starttime: null,
                endtime: null
            },
            start_flash: null,
            end_flash: null,
            start_flash_str: "",
            end_flash_str: "",
            searching: false,
            loading: false,
        }
    },
    async created() {
        await this.getGames()
        await this.getData()
        await this.search(1)
    },
    mounted() {

    },
    methods: {
        async getGames() {
            let response = await GameService.get()

            if (response.status) {
                this.games = response.result
            }
        },
        async getData() {
            let response = await WepayService.get('gtopup')

            if (response.status) {
                this.gameData = response.result
            }
        },
        getPackage(game_id) {
            let game = this.games.find(x => x.id == game_id)
            let company = this.gameData.find(x => x.company_id == game.company_id)
            if (company) {

                this.prices = company.denomination.map(x => x.price).sort((a, b) => a - b)
            }

        },
        async search(p = 0) {
            this.loading = true
            if (p > 0) {
                this.page = p
            }
            let response = await FlashPackageService.search(this.key, this.page, this.perpage)
            console.log('search response', response)
            if (response.status) {
                let { page, perpage, total, pages, data, flash_date } = response.result
                this.page = Number(page)
                this.perpage = Number(perpage)
                this.total = Number(total)
                this.pages = Number(pages)
                this.items = data
                this.flash_date = flash_date
                this.start_flash = flash_date && flash_date.starttime ? moment(flash_date.starttime).toDate() : null
                this.end_flash = flash_date && flash_date.endtime ? moment(flash_date.endtime).toDate() : null
                this.start_flash_str = this.start_flash ? moment(flash_date.starttime).format('DD/MM/YYYY HH:mm') : null
                this.end_flash_str = this.end_flash ? moment(flash_date.endtime).format('DD/MM/YYYY HH:mm') : null
            }
            this.loading = false
        },
        reset(p = 1) {
            this.key = ""
            this.game_id = 0
            this.start_flash = null
            this.end_flash = null
            this.search(p)
        },
        add() {
            this.game_id = 0
            this.start_flash = null
            this.end_flash = null
            this.package = {
                id: 0,
                game_id: 0,
                package_name: "",
                wepay_price: 0,
                wepay_price2: 0,
                wepay_price3: 0,
                wepay_price4: 0,
                price: 0,
                profit: 0,
                discount: 0,
                active: "1",
                created_by: this.user.id
            }
            $('#game-modal').modal('show')
        },
        edit(id) {

            let item = this.items.find(x => x.id == id)
            this.package = { ...item, updated_by: this.user.id }
            this.game_id = item.game_id
            this.getPackage(item.game_id)
            $('#game-modal').modal('show')
        },
        setting() {
            this.start_flash = this.flash_date && this.flash_date.starttime ? moment(this.flash_date.starttime).toDate() : null
            this.end_flash = this.flash_date && this.flash_date.endtime ? moment(this.flash_date.endtime).toDate() : null
            $('#flash-modal').modal('show')
        },
        async handleSave() {
            if (!this.validate()) {
                return false
            }

            if (this.package.id == 0) {
                await this.create()
            }
            else {
                await this.update()
            }

            $('#game-modal').modal('hide')
        },
        validate() {
            if (!this.package.package_name) {
                alertBox.error("กรุณากรอกชื่อแพ็กเกจ")
                return false
            }
            if (!this.game_id) {
                alertBox.error("กรุณาเลือกเกม")
                return false
            }
            if (!this.package.price || this.package.price <= 0) {
                alertBox.error("กรุณากรอกราคาที่ถูกต้อง")
                return false
            }
            if (!this.package.profit || this.package.profit < 0) {
                alertBox.error("กรุณากรอกกำไรที่ถูกต้อง")
                return false
            }
            

            return true
        },
        validateFlashDate() {
           
            if (!this.start_flash) {
                alertBox.error("กรุณาเลือกวันที่เริ่มต้น")
                return false
            }
            if (!this.end_flash) {
                alertBox.error("กรุณาเลือกวันที่สิ้นสุด")
                return false
            }

            return true
        },
        async create() {
            try {

                this.package.game_id = this.game_id
                let response = await FlashPackageService.create(this.package)

                if (response.status) {
                    alertBox.success('save success')
                    this.reset(this.page)
                }
                else {
                    alertBox.error("Error, " + response.error)
                }
            }
            catch (error) {
                alertBox.error("Error, " + error)
            }
        },
        async update() {
            try {
                this.package.game_id = this.game_id
                let response = await FlashPackageService.update(this.package)

                if (response.status) {
                    alertBox.success('save success')
                    this.reset(this.page)
                }
                else {
                    alertBox.error("Error, " + response.error)
                }
            }
            catch (error) {
                alertBox.error("Error, " + error)
            }
        },
        updateFlashDate() {
            if(!this.validateFlashDate()){
                return false
            }

            try {
                let data = {
                    id: this.flash_date.id,
                    starttime: this.start_flash ? moment(this.start_flash).format('YYYY-MM-DD HH:mm') : null,
                    endtime: this.end_flash ? moment(this.end_flash).format('YYYY-MM-DD HH:mm') : null
                }
                FlashPackageService.updateFlashDate(data)
                    .then(response => {
                        if (response.status) {
                            alertBox.success('save success')
                            this.start_flash_str = data.starttime ? moment(data.starttime).format('DD/MM/YYYY HH:mm') : null
                            this.end_flash_str = data.endtime ? moment(data.endtime).format('DD/MM/YYYY HH:mm') : null
                        }
                        else {
                            alertBox.error("Error, " + response.error)
                        }
                    })
                     $('#flash-modal').modal('hide')
            }
            catch (error) {
                alertBox.error("Error, " + error)
                 $('#flash-modal').modal('hide')
            }
        },
        async del(id) {
            let result = await alertBox.confirm('คุณแน่ใจที่จะลบ?')
            if (result) {
                let data = {
                    id: id,
                    updated_by: this.user.id
                }
                let response = await FlashPackageService.delete(data)

                if (response.status) {
                    this.reset(this.page)
                }
                else {
                    alertBox.error("Error, " + response.error)
                }
            }
        }

    },
    filters: {
        comma(value) {
            return helper.WithComma(value)
        },
        date(value) {
            if (!value) return ""

            return moment(value).format('DD/MM/YYYY HH:mm')
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Manage/FlashPackage.vue